/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line







  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

$(document).ready(function(){
    $('.custom_product_images').slick({
      dots: false,
      arrows: true,
      adaptiveHeight: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow:'<svg xmlns="http://www.w3.org/2000/svg" class="custom_product_slider_prevarrow" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg>',
      nextArrow:'<svg xmlns="http://www.w3.org/2000/svg" class="custom_product_slider_nextarrow" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg>',
      asNavFor: '.product_thumbnails'
  });
  $('.product_thumbnails').slick({
    vertical: true,
    focusOnSelect: true,
    verticalSwiping:true,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: false,
    arrows: true,
    asNavFor: '.custom_product_images'
  });

  $('.product_view_wrapper .four_products').on('click', function(){
    $('.custom__collection__products').addClass('collection-items--4');
    $('.custom__collection__products .product-grid-item').addClass('one-quarter');
    $(this).addClass('active');
    $('.product_view_wrapper .three_products').removeClass('active');
    $('.custom__collection__products .product-grid-item').removeClass('one-third');    
    $('.custom__collection__products').removeClass('collection-items--3');
  });
  $('.product_view_wrapper .three_products').on('click', function(){
    $('.custom__collection__products').addClass('collection-items--3');
    $('.custom__collection__products .product-grid-item').addClass('one-third');
    $(this).addClass('active');
    $('.product_view_wrapper .four_products').removeClass('active');
    $('.custom__collection__products .product-grid-item').removeClass('one-quarter');
    $('.custom__collection__products').removeClass('collection-items--4');
  });
})